import BranchesType from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  branchesPage: {
    loading: true,
    data: {}
  },
  bettingRates: {
    loading: true,
    data: []
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  list: {
    loading: true,
    data: []
  },
  otherList: {
    loading: true,
    data: []
  },
  igarashiList: {
    loading: true,
    data: []
  },
  history: {
    loading: true,
    data: {}
  }
}

const Branches = (state = INIT_STATE, action) => {
  switch (action.type) {
    case BranchesType.GET_BRANCHES_PAGES_SUCCESS:
      return {
        ...state,
        branchesPage: action.payload,
      }
    case BranchesType.GET_BRANCHES_HISTORIES_PAGES_SUCCESS:
      return {
        ...state,
        history: action.payload,
      }
    case BranchesType.GET_BRANCH_BETTING_RATE_TYPE_SUCCESS:
      return {
        ...state,
        bettingRates: action.payload,
      }
    case BranchesType.GET_DETAIL_BRANCH_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case BranchesType.PUT_BRANCH_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case BranchesType.POST_BRANCH_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case BranchesType.GET_BRANCHES_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }
    case BranchesType.GET_BRANCH_IGARASHI_LIST_SUCCESS:
      return {
        ...state,
        igarashiList: action.payload,
      }

    case BranchesType.GET_BRANCH_OTHER_LIST_SUCCESS:
      return {
        ...state,
        otherList: action.payload,
      }

    default:
      return state
  }
}

export default Branches
